import React, { Component } from 'react';
import { translate } from 'react-i18next';

class ModulePeugeotEcommerceProductPaymentMethos extends Component {
    render() {
        return (
            <div>
                <div className="ft-info-left dv-content-ft col-md-6">
                    <h4>Các hình thức thanh toán tại phutungpeugeot.com</h4>
                    <div id="payment-list">
                        <div className="payment-item">
                            <div className="payment-img">
                                <img src="/img/office-icon.png" alt="icon-phutungsuzuki" title="icon-phutungsuzuki" className="img-responsive" />
                            </div>
                            <div className="content-wp">
                                <h6>Thanh toán trực tiếp tại các văn phòng VHP Auto</h6>
                                <span>
                                    Sử dụng khi khách hàng có nhu cầu mua hàng trực tiếp tại cửa hàng.
                                  </span>
                            </div>

                        </div>
                        <div className="payment-item">
                            <div className="payment-img">
                                <img src="/img/post-office.png" alt="icon-phutungsuzuki" title="icon-phutungsuzuki" className="img-responsive" />
                            </div>
                            <div className="content-wp">
                                <h6>Thanh toán qua bưu điện - dịch vụ chuyển tiền</h6>
                                <span>
                                    Sử dụng khi khách hàng ở xa, không thuận tiện cho việc giao dịch trực tiếp cũng như qua ngân hàng. Sau khi nhận được tiền chúng tôi sẽ chuyển hàng đúng đủ, theo chất lượng quý khách hàng yêu cầu.
                                  </span>
                            </div>

                        </div>
                        <div className="payment-item">
                            <div className="payment-img">
                                <img src="/img/Coach-icon.png" alt="icon-phutungsuzuki" title="icon-phutungsuzuki" className="img-responsive" />
                            </div>
                            <div className="content-wp">
                                <h6>Thanh toán nhà xe vận chuyển</h6>
                                <span>
                                    Chúng tôi sẽ chuyển hàng qua nhà xe, quý khách nhận hàng và thanh toán trực tiếp cho nhà xe vận chuyển.
                                  </span>
                            </div>

                        </div>
                        <div className="payment-item">
                            <div className="payment-img">
                                <img src="/img/bank-icon.png" alt="icon-phutungsuzuki" title="icon-phutungsuzuki" className="img-responsive" />
                            </div>
                            <div className="content-wp">
                                <h6>Thanh toán qua chuyển khoản ngân hàng</h6>
                                <span>
                                    Quý khách có thể thanh toán cho chúng tôi bằng cách chuyển khoản trực tiếp tại ngân hàng, chuyển qua thẻ ATM, hoặc qua Internet
                                Banking.
                                  </span>
                            </div>

                            <div className="bank-logo">

                                <div className="bank-item">

                                    <img src="/img/MBB.gif" alt="Ngân hàng Quân Đội" title="icon-phutungsuzuki" />

                                    <img src="/img/VPB.gif" alt="Ngân hàng TMCP Việt Nam Thịnh Vượng" title="icon-phutungsuzuki" />

                                    <img src="/img/VCB.gif" alt="Ngân hàng TMCP Ngoại thương Việt Nam - Vietcombank" title="icon-phutungsuzuki" />

                                    <img src="/img/TCB.gif" alt="Ngân hàng TMCP Kỹ Thương Việt Nam - Techcombank" title="icon-phutungsuzuki" />

                                    <img src="/img/SCB.gif" alt="Ngân hàng TMCP Sài Gòn Thương Tín" title="icon-phutungsuzuki" />

                                    <img src="/img/BIDV.gif" alt="Ngân hàng Đầu Tư Và Phát Triển Việt Nam - BIDV" title="icon-phutungsuzuki" />

                                    <img src="/img/AGR.gif" alt="Ngân hàng Nông Nghiệp Và Phát Triển Nông Thôn Việt Nam - Agribank" title="icon-phutungsuzuki" />

                                    <img src="/img/MSB.gif" alt="Ngân hàng TMCP Hàng Hải Việt Nam" title="icon-phutungsuzuki" />

                                    <img src="/img/VTB.gif" alt="Ngân hàng TMCP Công Thương Việt Nam - Vietinbank" title="icon-phutungsuzuki" />

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="ft-info-right dv-content-ft col-md-6">
                    <h4>Thông tin tài khoản ngân hàng</h4>
                    <div id="review-list">
                        <div className="review-item">
                            <div className="review-img">
                                <img src="/img/icon-money.png" alt="" title="" />
                            </div>
                            <div className="content-wp">
                                <h5><span style={{ "textDecoration": "underline" }}><em><strong>VIETINBANK</strong></em></span></h5>
                                <p>Chi nhánh: VIETINBANK CN Hai Bà Trưng – Hà Nội</p>
                                <h6>Số TK: 110000064709 &nbsp; :|: &nbsp;&nbsp;Chủ TK: Cty TNHH XNK và Kinh Doanh VHP</h6>
                            </div>

                        </div>
                        <div className="review-item">
                            <div className="review-img">
                                <img src="/img/icon-money.png" alt="" title="" />
                            </div>
                            <div className="content-wp">
                                <h5><span style={{ "textDecoration": "underline" }}><em><strong>AGRIBANK</strong></em></span></h5>
                                <p>Chi nhánh: AGRIBANK CN Thăng Long – Hà Nội</p>
                                <h6>Số TK: 1300206057803 &nbsp; :|: &nbsp;&nbsp;Chủ TK: Vũ Ngọc Huyền</h6>
                            </div>

                        </div>
                        <div className="review-item">
                            <div className="review-img">
                                <img src="/img/icon-money.png" alt="" title="" />
                            </div>
                            <div className="content-wp">
                                <h5><span style={{ "textDecoration": "underline" }}><em><strong>VIETCOMBANK</strong></em></span></h5>
                                <p>Chi nhánh: VIETCOMBANK Hội sở Hà Nội Số</p>
                                <h6>Số TK: 0011004113667 &nbsp; :|: &nbsp;&nbsp;Chủ TK: Vũ Ngọc Huyền</h6>
                            </div>

                        </div>
                        <div className="review-item">
                            <div className="review-img">
                                <img src="/img/icon-money.png" alt="" title="" />
                            </div>
                            <div className="content-wp">
                                <h5><span style={{ "textDecoration": "underline" }}><em><strong>VIETINBANK</strong></em></span></h5>
                                <p>Chi nhánh: VIETINBANK CN Hai Bà Trưng – Hà Nội</p>
                                <h6>Số TK: 101003852917 &nbsp; :|: &nbsp;&nbsp;Chủ TK: Vũ Ngọc Huyền</h6>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default translate('translations')(ModulePeugeotEcommerceProductPaymentMethos);


// WEBPACK FOOTER //
// ./src/modules/Peugeot/Ecommerce/Product/PaymentMethods.js